module.exports = __webpack_public_path__ + "media/images/patient-icons/question-icon-b456fb83e8dc90a1a2dd437dc7977352.svg";